<div id="big_guide_wrap" [ngStyle]="{'font-size': isHarmonyOS ? '14px' : ''}" >
  {{content}}
</div>



// WEBPACK FOOTER //
// ./src/app/big-guide/big-guide.component.html